import React, { createRef, useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import Preview from './Preview'
import LowLatencyEncoderPreview from '../../../metadata/components/encoders/children/LowLatencyEncoderPreview.js'
import actions from '../../../redux/actions'

function getEncoder(event, encoders) {
  const assignedEncoder = event.assignedEncoder
  return encoders.data.find((enc) => enc.encoderID === assignedEncoder) || null
}

const useEventSource = ({eventID}) => {
  const clientID = useSelector((state) => state.data.client.clientID)
  const controlcenterDomainRestrictionOverride = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9"
  return `https://api.v3.invintus.com/StreamURI/hls/${clientID}/${eventID}/${controlcenterDomainRestrictionOverride}/media.m3u8`
}

const PreviewContainer = (props) => {
  const { event, encoders, preview, setPreview } = props

  const eventStatus = event.eventStatus
  let encoder = getEncoder(event, encoders)
  const defaultSource = useEventSource({eventID: event.eventID})
  const liveSource = event.streamingURIs && event.streamingURIs.main

  if (
    preview &&
    ((encoder && encoder.previewURI) ||
      eventStatus === 'published' ||
      eventStatus === 'live' ||
      eventStatus === 'on break' ||
      eventStatus === 'stopping')
  ) {
    const isPublished = event.eventStatus === 'published'
    const source = liveSource === 'live-encoder' ? liveSource : defaultSource

    let previewElement = null
    if (isPublished || (eventStatus === 'live' || eventStatus === 'on break') && preview.type !== 'source-encoder') {
      previewElement = (
        <Preview
          source={source}
          thumbnail={event.videoThumbnail}
          captionPath={event.captionPath}
          innerRef={createRef()}
          autoPlay={false}
          bigPlayButton={true}
        />
      )
    } else if (
      (encoder &&
        encoder.lowLatencyPreview &&
        preview.type === 'source-encoder') ||
      liveSource
    ) {
      previewElement = <LowLatencyEncoderPreview encoder={encoder} />
    }

    return <div className='player'>{previewElement}</div>
  } else if (
    event.videoThumbnail !== null &&
    event.videoThumbnail !== '' &&
    eventStatus === 'published'
  ) {
    var thumb = event.videoThumbnail

    /**
     * Event is published and has global thumb assigned
     */
    return (
      <div className='snapshot'>
        <img
          src={thumb}
          onClick={() => {
            setPreview({
              type: 'asset',
              context:
                eventStatus != 'published' ? 'first-available' : 'published',
            })
          }}
        />
      </div>
    )
  } else if (encoder && encoder.online === true && encoder.previewURI) {
    return (
      <div className='snapshot no-media'>
        <span className='fa-stack fa-lg'>
          <i className='fa fa-video-camera fa-stack-1x'></i>
        </span>
        <span>Select Source</span>
      </div>
    )
  } else {
    return (
      <div className='snapshot no-media'>
        <span className='fa-stack fa-lg'>
          <i className='fa fa-video-camera fa-stack-1x'></i>
          <i className='fa fa-ban fa-stack-2x'></i>
        </span>
        <span>No Video Media Available</span>
      </div>
    )
  }
}

const PreviewSources = (props) => {
  const { event, encoders, autoSelect, requestEvent } = props
  const [preview, setPreview] = useState(null)

  useEffect(() => {
    //on load if preview should be auto selected open the preview if possible
    if (autoSelect) {
      if (event.eventStatus === 'live') {
        setPreview({
          type: 'live-encoder',
          context: null,
        })
      } else if (event.eventStatus === 'published') {
        // if (event.mediaAssets === undefined) {
        //   // request full event to get media assets
        //   requestEvent(event.eventID)
        // }
        setPreview({
          type: 'asset',
          context: 'published',
        })
      } else if (event.assignedEncoder) {
        const eventEncoder = getEncoder(event, encoders)
        if (eventEncoder && eventEncoder.online) {
          setPreview({
            type: 'source-encoder',
            context: null,
          })
        }
      }
    }
  }, [])

  var streamOptions = []
  // var mediaOptions = [];
  var noStreamsAvialble = (
    <li
      className='dropdown-header disabled'
      key={'source-select-heading-encoders-null-' + event.eventID}
    >
      No Previewable Streams
    </li>
  )

  if (event.assignedEncoder === null) {
    streamOptions.push(noStreamsAvialble)
  } else {
    const eventEncoder = getEncoder(event, encoders)
    const online = eventEncoder && eventEncoder.online
    streamOptions.push(
      <li className='dropdown-header' key={'source-select-heading-encoders-' + event.eventID}>
        Streams
      </li>
    )
    streamOptions.push(
      <li
        disabled={online === false}
        className='preview-select'
        key={'source-select-encoder-' + event.eventID}
      >
        <a
          href='about:blank'
          onClick={(ev) => {
            ev.preventDefault()
            if (online) {
              setPreview({
                type: 'source-encoder',
                context: null,
              })
            }
          }}
        >
          {online ? 'Source Encoder' : 'Encoder Offline'}
        </a>
      </li>
    )
  }

  if (event.eventStatus === 'live') {
    streamOptions.push(
      <li
        className='preview-select'
        key={'source-select-live-' + event.eventID}
      >
        <a
          href='about:blank'
          onClick={(ev) => {
            ev.preventDefault()
            setPreview({
              type: 'live-encoder',
              context: null,
            })
          }}
        >
          Live
        </a>
      </li>
    )
  }

  return (
    <div className='col-xs-10 preview-column'>
      <div className='event-preview-selector'>
        <div className='col-xs-12 sources fullheight'>
          <div className='dropdown fullheight'>
            <div className='btn-group fullheight'>
              <button
                type='button'
                className='btn btn-default dropdown-toggle fullheight'
                data-toggle='dropdown'
                aria-expanded='false'
              >
                Select Preview Source <span className='caret'></span>
              </button>

              <ul className='dropdown-menu' role='menu'>
                {streamOptions}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='event-preview'>
        <PreviewContainer event={event} encoders={encoders} preview={preview} setPreview={setPreview}/>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  requestEvent: (eventID) => dispatch(actions.data.requestFullEvent(eventID)),
})

export default connect(null, mapDispatchToProps)(PreviewSources)
